import ExpandContent from "./ExpandContent";
import LazyLoad from "./LazyLoad";
import ObjectFit from "./ObjectFit";
import SlideBlocks from "./SlideBlocks";
import ToggleOverlay from "./ToggleOverlay";
import ToggleSearchOverlay from "./ToggleSearchOverlay";
import RenderMap from "./RenderMap";
import ControlOverlays from "./ControlOverlays";
import BuildFootnotes from "./BuildFootnotes";
import HighlightActivePageSection from "./HighlightActivePageSection";

export default {
  ExpandContent,
  LazyLoad,
  ObjectFit,
  SlideBlocks,
  ToggleOverlay,
  ToggleSearchOverlay,
  RenderMap,
  ControlOverlays,
  BuildFootnotes,
  HighlightActivePageSection,
};
